import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HeaderComponent} from "./components/header/header.component";
import {NgClass, NgIf} from "@angular/common";
import {SectionColor, SectionComponent} from "./components/section/section.component";
import {HeroSectionComponent} from "./components/hero-section/hero-section.component";
import {ImageComponent} from "./shared/image/image.component";
import {CardComponent} from "./shared/card/card.component";
import {PopupComponent} from "./components/popup/popup.component";
import {LoginService} from "./components/login-dialog/services/login.service";
import {FooterComponent} from "./components/footer/footer.component";
import {environment} from "../environments/environment";
import {CookieConsentComponent} from "./components/cookie-consent/cookie-consent.component";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    RouterOutlet,
    HeaderComponent,
    NgIf,
    NgClass,
    SectionComponent,
    HeroSectionComponent,
    ImageComponent,
    CardComponent,
    PopupComponent,
    FooterComponent,
    CookieConsentComponent,
  ]
})
export class AppComponent implements OnInit{
  @ViewChildren(CardComponent) cards!: QueryList<CardComponent>;
  @ViewChildren('line') lines!: QueryList<ElementRef>;
  isCardUploadOpen = false; // Variable pour contrôler l'ouverture de la div
  isCardScrappingOpen = false; // Variable pour contrôler l'ouverture de la div
  isCardChatBotOpen = false; // Variable pour contrôler l'ouverture de la div
  isLoggedIn = false;
  apiUrl!: string;
  currentCardIndex = 0;

  constructor(private loginService: LoginService) {
  }

  ngOnInit(): void {
    this.startAnimation();
    this.apiUrl = this.environment.athenaApiUrl;
    // S'abonner à l'état d'authentification
    this.loginService.isAuthenticated$.subscribe(
      (isAuthenticated) => this.isLoggedIn = isAuthenticated
    );
  }

  // Fonction déclenchée lors du clic sur une carte
  onCardUploadClicked() {
    this.isCardUploadOpen = !this.isCardUploadOpen; // Basculer l'état ouvert/fermé
    this.isCardScrappingOpen = false;
  }

  onCardScrappingClicked(){
    this.isCardScrappingOpen =!this.isCardScrappingOpen; // Basculer l'état ouvert/fermé
    this.isCardUploadOpen = false;
  }

  onCardChatBotClicked() {
    this.isCardChatBotOpen = !this.isCardChatBotOpen; // Basculer l'état ouvert/fermé
  }

  startAnimation() {
    let currentIndex = 0;

    setInterval(() => {
      // Réinitialiser tous les états "isHovered" des cartes
      this.cards.forEach(card => (card.isHovered = false));
      this.lines.forEach(line => line.nativeElement.classList.remove('active'));

      // Activer "isHovered" sur la carte actuelle
      const cardsArray = this.cards.toArray();
      const arrowsArray = this.lines.toArray();

      cardsArray[currentIndex].isHovered = true;

      // Activer la flèche correspondante
      if (currentIndex < arrowsArray.length) {
        arrowsArray[currentIndex].nativeElement.classList.add('active');
      }

      // Passer à la carte suivante
      currentIndex = (currentIndex + 1) % cardsArray.length; // Reboucler après la dernière carte
    }, 4000); // Durée pour chaque étape
  }

  protected readonly SectionColor = SectionColor;
  protected readonly environment = environment;
}
